import { render, staticRenderFns } from "./CertificateRecord_list.vue?vue&type=template&id=81286f12&scoped=true"
import script from "./CertificateRecord_list.vue?vue&type=script&lang=js"
export * from "./CertificateRecord_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81286f12",
  null
  
)

export default component.exports